import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Button from "../../../components/button";
import "../../../styles/Access.css";
import "../../../styles/DriverPayments.css";
import "../../../styles/DriverSafety.css";
import "../../../styles/Issue.css";
import "../../../styles/Trip.css";
import "../../../styles/TripCostEstimation.css";

const RunSalaryCalculation = () => {
  const navigate = useNavigate();

  return (
    <div className="create_vehicle_page trip_cost_estimation_create_page driver_payments_create_page">
      <Breadcrumbs values={["Finance", "Driver Payments", "Run Salary Calculation"]} />

      <div className="page_header access_view">
        <h2>Run Salary Calculation</h2>

        <div className="d-flex align-items-center gap-2">
          <Button
            cancelBtn={() => navigate("/driver-payments")}
            shouldRow={false}
            isShowSubmitBtn={false}
            cancelBtnText="Back"
          />
        </div>
      </div>

      <div className="page_container">
        <div className="trip_information_main_div driver_form_shell driver_payments_create_shell">
          <div className="driver_form_content">
            <div className="driver_form_section">
              <div className="driver_form_section_header">
                <h3>API-Driven Flow</h3>
                <p>
                  The old mock salary-run generator has been removed. Driver payments are now
                  expected to come from the backend payment payload.
                </p>
              </div>

              <div className="driver_payments_review_card">
                <p style={{ marginBottom: 12 }}>
                  This page will be re-enabled once create/update endpoints for driver payments are
                  connected in the frontend.
                </p>
                <p style={{ marginBottom: 0 }}>
                  You can still review synced records from the Driver Payments listing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RunSalaryCalculation;
